import React from 'react'
import { DraggableStateSnapshot } from 'react-beautiful-dnd'
import { ANIMATION_SCALE } from '../../style'

const patchDraggableStyle = (
  style: React.CSSProperties | undefined,
  snapshot: DraggableStateSnapshot,
  options: {
    fadeWithoutHover?: boolean
  } = {}
): React.CSSProperties => {
  if (snapshot.isDropAnimating && !snapshot.draggingOver) {
    // Do the cancel animation
    const duration = 0.4 * ANIMATION_SCALE
    const curve = 'ease-out'

    return {
      ...style,
      opacity: 0,
      filter: 'blur(20px)',
      transition: [
        // Transform will be reset to 0 and we don't know the original transform
        // So delay the animation until the fade-out is done :D
        `transform 0s ${curve} ${duration}s`,
        `opacity ${duration}s ${curve}`,
        `filter ${duration}s ${curve}`
      ].join(', ')
    }
  }

  if (snapshot.isDropAnimating) {
    // debugger
  }

  return {
    ...style,
    opacity: !options.fadeWithoutHover || snapshot.draggingOver ? 1 : 0.5
  }
}

export default patchDraggableStyle
